import listComponent from '@/util/proto/listComponent'
import View from './view'
import TimeRange from '../partial/time-range'
import CompanySelect from '../partial/company-select'
import { saveFile } from '@/util'
import Chart from '../partial/chart'
import LicenseSelect from '../../license/partial/license-select'
export default {
  extends: listComponent,
  mixins: [global],
  data() {
    return {
      columns: [{
          title: '序号',
          type: 'index',
          align: 'center',
          width: 60,
        },
        {
          title: '企业',
          key: 'companyName',
          minWidth: 250,
          render: (h, { row }) => {
            return <div style="flex: 1 1 auto;">
              <div class="tb-list-item-cell">
                <div class="tb-list-item-cell-l">
                  <span style="font-size:14px;">{row.companyName}</span>
                  <span style="font-size:11px;color:rgba(0,0,0,.6);font-size:12px;"></span>
                </div>
                <div class="tb-list-item-cell-r">
                  <Icon style={{'marginRight':'5px'}} type="md-phone-portrait" />
                  <span>{row.companyPhone}</span>
                </div>
              </div>
              <div class="tb-list-item-cell">
                <div class="tb-list-item-cell-l light" style="font-size:12px;">{row.businessAddress}</div>
                <div class="tb-list-item-cell-r">
                  <Icon custom="i-icon icon-credentials" style="margin-right:5px;" />
                  <span>{row.legalName}</span>
                </div>
              </div>
            </div>
          }
        },
        {
          title: '出围栏预警',
          key: 'inNum',
          minWidth: 100,
          // sortable:true,
        },
        {
          title: '入围栏预警',
          key: 'outNum',
          minWidth: 100,
          // sortable:true,
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: "right",
          align: 'center',
          render: (h, { row }) => {

            let acts = [
              <a on-click={()=>this.view(row)}>查看明细</a>,
            ]

            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],

      chartData: [],

      params: {
        companyName: null,
        name:null,
        licenseId:null,
        rangeTime: null,
      },
      chartVisible: false,
      loading: false
    }
  },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  computed:{
    fences(){
      return this.$request.fenceAll().then(resp => {
        return Promise.resolve( resp.data.map(i => ({
          value:i.id,
          label:i.name
        })))
      })
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search() {
      let { rangeTime , ...search } = this.params
      if( rangeTime ){
        search.startDateTime = rangeTime[0]
        search.endDateTime = rangeTime[1]
      }

      let params = { search, pageSize: this.page.pageSize, pageNum: this.page.pageNum, orders: this.page.orders }
      this.loading = true
      this.$request.fenceAlarmStats(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], {})
          this.convChartData(this.data)
          this.page.total = resp.data.total || 0
        }
      })
    },

    //查看
    view(row) {
      let { rangeTime } = this.params
      let params = {
        companyName :row.companyName,
      }
      if(rangeTime){
        params.startDateTime = rangeTime[0]
        params.endDateTime = rangeTime[1]
      }
      this.$refs['itemView'].init(params)
    },

    remove(row) {
      this.$ui.confirm(this.$request.assSupplierDelete, `确定删除 ${row.supplierName} ？`)(row.id).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('删除成功')
          this.search()
        } else {
          this.$Message.error(resp.msg)
        }
      })
    },


    reset() {
      for (let i in this.params) {
        this.params[i] = null
      }
      this.search()
    },
    handleExport() {
      let { rangeTime , ...options } = this.params

      if(rangeTime){
        options.startDateTime = rangeTime[0]
        options.endDateTime = rangeTime[1]
      }
      this.$request.statsCompanyViolationExport(options).then(resp => {
        saveFile(resp)
      })
    },
    handleChangeTime(v) {
      this.search()
    },
    convChartData(d) {
      let ret = [],
        props = [
          ['inNum', '入围栏预警'],
          ['outNum', '出围栏预警'],
        ]
      for (let i of d) {
        for (let j of props) {
          ret.push({ label: i.companyName, value: i[j[0]], type: j[1] })
        }
      }
      this.chartData = ret
    }
  },
  render() {
    const { params } = this
    const chartNode = this.chartVisible ? <Chart data={this.chartData} /> : null
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <Input v-model={params.companyName} placeholder="所属企业" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select dict={this.fences} v-model={params.gfId} placeholder="选择围栏" />
            </sl-search-item>
            <template slot="action">
              <Button style="margin-bottom:8px;" disabled={this.data.length == 0} type="primary" icon="md-download" on-click={this.handleExport}>导出</Button>
            </template>  
          </sl-search>
        </div>
        <div class="flex" style="margin-bottom:16px;">
          <TimeRange size="small" v-model={this.params.rangeTime} on-change={this.handleChangeTime} default-value="all" />
          <div>
            <i-switch size="small" style="margin-right:5px;" v-model={this.chartVisible}></i-switch>
            <span>显示图表</span>
          </div>
        </div>
        <div class="pg-bd">
          { chartNode }
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <View ref="itemView" />
      </sl-page>
    )
  }
}
